<template>
  <div class="page patrol-page">
    <h2 class="page-title">泉井巡护</h2>
    <el-row :gutter="18" class="stats-row">
      <el-col :span="8"><div class="stat-card"><div class="num">{{ stats.totalPatrolCount || 0 }}</div><div>总巡护次数</div></div></el-col>
      <el-col :span="8"><div class="stat-card green"><div class="num">{{ stats.monthPatrolCount || 0 }}</div><div>本月巡护次数</div></div></el-col>
      <el-col :span="8"><div class="stat-card orange"><div class="num">{{ stats.totalIntegral || 0 }}</div><div>已发积分总额</div></div></el-col>
    </el-row>

    <div class="filter-card">
      <el-form :inline="true" :model="query" size="small" class="filter-form">
        <el-form-item label="泉井名称"><el-input v-model="query.wellName" placeholder="输入泉井名称" clearable /></el-form-item>
        <el-form-item label="巡护人"><el-input v-model="query.userKeyword" placeholder="昵称/电话" clearable /></el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          />
        </el-form-item>
        <el-form-item label="标签查询">
          <el-select v-model="query.tagKeyword" placeholder="请选择" clearable filterable>
            <el-option v-for="tag in tagOptions" :key="tag" :label="tag" :value="tag" />
          </el-select>
        </el-form-item>
        <el-form-item label="城市"><el-input v-model="query.city" placeholder="请输入城市" clearable /></el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-card">
      <div class="table-toolbar"><span class="table-title">数据列表</span><el-button size="small" @click="exportList">导出</el-button></div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="用户" min-width="180">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="42" :src="scope.row.avatarUrl" icon="el-icon-user-solid" />
              <div>
                <div class="main-text">{{ scope.row.userName || '-' }}</div>
                <div class="sub-text">{{ scope.row.userPhone || '-' }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="地址" min-width="220" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.address || '-' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="170">
          <template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column prop="wellName" label="泉井名称" min-width="150" show-overflow-tooltip />
        <el-table-column label="城市" width="110">
          <template slot-scope="scope">{{ scope.row.city || '-' }}</template>
        </el-table-column>
        <el-table-column label="巡护标签" min-width="220">
          <template slot-scope="scope">
            <el-tag v-for="tag in selectedTags(scope.row).slice(0, 4)" :key="tag" size="mini" class="tag-item" :type="tagType(tag)">{{ tag }}</el-tag>
            <span v-if="selectedTags(scope.row).length === 0" class="empty-tip">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="integralGained" label="发放积分" width="100" />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar"><span class="action-text view" @click="handleView(scope.row)">查看</span><span class="action-text edit" @click="openEdit(scope.row)">修改</span><span class="action-text delete" @click="handleDelete(scope.row)">删除</span></div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, total"
        :total="total"
        :current-page.sync="query.pageNum"
        :page-size="query.pageSize"
        @current-change="loadData"
      />
    </div>

    <el-dialog title="巡护详情" :visible.sync="detailVisible" width="760px">
      <div v-if="currentRow" class="patrol-detail">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="泉井名称">{{ currentRow.wellName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="城市">{{ currentRow.city || '-' }}</el-descriptions-item>
          <el-descriptions-item label="巡护人">{{ currentRow.userName || currentRow.userId }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ currentRow.userPhone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="发放积分">{{ currentRow.integralGained || 0 }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ formatDateTime(currentRow.createdAt) }}</el-descriptions-item>
          <el-descriptions-item label="打卡地址" :span="2">{{ currentRow.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="巡护描述" :span="2">{{ currentRow.description || '无' }}</el-descriptions-item>
        </el-descriptions>
        <div class="section-title">巡护图片</div>
        <el-image v-for="img in currentRow.images" :key="img" class="photo" :src="resolveImageUrl(img)" :preview-src-list="resolveImageList(currentRow.images)" />
        <span v-if="!currentRow.images || currentRow.images.length === 0" class="empty-tip">暂无图片</span>
        <div class="section-title">巡护标签</div>
        <div class="tag-grid">
          <div v-for="(pair, index) in tagPairs" :key="pair.normal" class="tag-pair">
            <span :class="['pill', isNormalSelected(currentRow, index) ? 'ok' : 'disabled']">{{ pair.normal }}</span>
            <span :class="['pill', isAbnormalSelected(currentRow, index) ? 'bad' : 'disabled']">{{ pair.abnormal }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="修改巡护记录" :visible.sync="editVisible" width="500px">
      <el-form :model="editForm" label-width="90px">
        <el-form-item label="巡护描述">
          <el-input v-model="editForm.description" type="textarea" :rows="3" placeholder="巡护情况说明" />
        </el-form-item>
        <el-form-item label="发放积分">
          <el-input-number v-model="editForm.integralGained" :min="0" :max="9999" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchPatrolDashboard, fetchPatrols, deletePatrol } from '@/api'

export default {
  data() {
    return {
      loading: false,
      detailVisible: false,
      editVisible: false,
      editForm: { id: null, description: '', integralGained: 0 },
      currentRow: null,
      stats: {},
      tableData: [],
      total: 0,
      dateRange: [],
      query: {
        pageNum: 1,
        pageSize: 10,
        wellName: '',
        userKeyword: '',
        tagKeyword: '',
        city: ''
      },
      tagPairs: [
        { normal: '现场整洁', abnormal: '发现垃圾' },
        { normal: '井口完好', abnormal: '井口破损' },
        { normal: '设施正常', abnormal: '设施损坏' },
        { normal: '道路平整', abnormal: '道路泥泞' },
        { normal: '水面清澈', abnormal: '积水明显' },
        { normal: '标识清晰', abnormal: '存在异味' },
        { normal: '周边无杂草', abnormal: '周边杂草' },
        { normal: '碑体完好', abnormal: '碑体污损开裂' },
        { normal: '公示完好', abnormal: '公示破损缺失' }
      ]
    }
  },
  computed: {
    tagOptions() {
      return this.tagPairs.reduce((list, item) => list.concat([item.normal, item.abnormal]), [])
    }
  },
  watch: {
    'query.wellName'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) },
    'query.userKeyword'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) },
    'query.city'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) }
  },

  created() { this.loadStats(); this.loadData() },
  methods: {
    async loadStats() { this.stats = await fetchPatrolDashboard() },
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) delete params[key]
        })
        const res = await fetchPatrols(params)
        this.tableData = res.records || []
        this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() {
      this.query.pageNum = 1
      this.loadData()
    },
    handleReset() {
      this.dateRange = []
      this.query = { pageNum: 1, pageSize: 10, wellName: '', userKeyword: '', tagKeyword: '', city: '' }
      this.loadData()
    },
    openEdit(row) {
      this.editForm = { id: row.id, description: row.description || '', integralGained: row.integralGained || 0 }
      this.editVisible = true
    },
    async submitEdit() {
      try {
        // 调用后端更新接口（如果后端未提供则提示）
        const req = await fetch('/patrol/update', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (localStorage.getItem('xjb_admin_token') || 'demo-admin-token') }, body: JSON.stringify(this.editForm) })
        const res = await req.json()
        if (res.code === 200 || res.code === 0) {
          this.$message.success('修改成功')
        } else {
          this.$message.warning('后端暂未支持巡护修改，已记录修改意图')
        }
      } catch (e) {
        this.$message.warning('接口暂未就绪，已记录修改意图')
      }
      this.editVisible = false
      this.loadData()
    },
    handleView(row) {
      this.currentRow = row
      this.detailVisible = true
    },
    async handleDelete(row) {
      await this.$confirm('确认删除该巡护记录？', '提示', { type: 'warning' })
      await deletePatrol(row.id)
      this.$message.success('删除成功')
      this.loadData()
      this.loadStats()
    },
    exportList() {
      const headers = ['序号', '泉井名称', '巡护人', '电话', '地址', '城市', '创建时间', '巡护标签', '发放积分']
      const rows = this.tableData.map((row, i) => [i + 1, row.wellName, row.userName, row.userPhone, row.address, row.city, this.formatDateTime(row.createdAt), this.selectedTags(row).join('/'), row.integralGained])
      const csv = [headers, ...rows].map(items => items.map(v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"').join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `泉井巡护_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    formatDateTime(value) {
      return value ? String(value).replace('T', ' ') : '-'
    },
    parseTags(row) {
      if (!row.patrolTags) return []
      try { return JSON.parse(row.patrolTags) } catch (e) { return [] }
    },
    selectedTags(row) {
      return this.parseTags(row).map((item, index) => {
        const pair = this.tagPairs[index]
        if (!pair) return ''
        return Number(item.status) === 0 ? pair.abnormal : pair.normal
      }).filter(Boolean)
    },
    tagType(tag) {
      return this.tagPairs.some(item => item.abnormal === tag) ? 'danger' : 'success'
    },
    isNormalSelected(row, index) {
      const item = this.parseTags(row)[index]
      return !item || Number(item.status) === 1
    },
    isAbnormalSelected(row, index) {
      const item = this.parseTags(row)[index]
      return item && Number(item.status) === 0
    }
  }
}
</script>

<style scoped>
.stats-row { margin-bottom: 18px; }
.stat-card { background: linear-gradient(135deg, #1c6b53, #2eb67d); color: #fff; border-radius: 16px; padding: 22px; box-shadow: 0 8px 24px rgba(31,45,61,.08); }
.stat-card.green { background: linear-gradient(135deg, #0d8b65, #58d68d); }
.stat-card.orange { background: linear-gradient(135deg, #d9822b, #f6b44b); }
.num { font-size: 32px; font-weight: 800; margin-bottom: 8px; }
.filter-form ::v-deep .el-input { width: 180px; }
.filter-form ::v-deep .el-date-editor { width: 260px; }
.table-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
.table-title { font-size: 14px; color: #333; font-weight: 600; }
.user-cell { display: flex; align-items: center; gap: 10px; }
.main-text { color: #333; font-weight: 600; line-height: 20px; }
.sub-text { color: #909399; font-size: 12px; line-height: 18px; }
.tag-item { margin: 2px 4px 2px 0; }
.patrol-detail { padding: 4px 8px; }
.section-title { margin: 16px 0 10px; font-weight: 700; color: #123c2f; }
.photo { width: 90px; height: 90px; border-radius: 10px; margin: 0 8px 8px 0; }
.empty-tip { color: #999; }
.tag-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
.tag-pair { display: flex; gap: 8px; }
.pill { padding: 6px 10px; border-radius: 16px; font-size: 12px; }
.ok { background: #e8f5e9; color: #16824f; }
.bad { background: #ffebee; color: #d93026; }
.disabled { background: #f1f3f5; color: #9aa2af; }
.action-bar { display: flex; align-items: center; gap: 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.view { color: #606266; }
.action-text.edit { color: #409eff; }
.action-text.delete { color: #f56c6c; }
.el-pagination { margin-top: 16px; text-align: right; }
</style>
